/* eslint-disable */
export default {
  feedbackHeader: '提交反馈',
  back: '返回',
  revert: '复原',
  instruction:
    '您的反馈对我们很有价值。如果您在使用应用程序时遇到问题、想要申请功能或报告错误，我们非常乐意为您提供帮助。',
  fillForm: '请填写下表并点击 ',
  useMailBox: ' 或直接使用您的邮箱将您的请求发送至 ',
  email: '您的电子邮件地址',
  reply: '（方便我们回复您）',
  emailPlaceHolder: 'ronald.app@ringcentral.com',
  feedbackTopic: '反馈主题',
  topicPlaceHolder: '请选择一个选项',
  bugReport: '错误报告',
  featureRequest: '功能请求',
  others: '其他',
  subject: '主题',
  subjectPlaceHolder: '告诉我们您需要什么帮助',
  description: '完整说明',
  descriptionPlaceHolder: '请尽可能多地提供相关信息',
  send: '发送您的反馈',
} as const;

// @key: @#@"feedbackHeader"@#@ @source: @#@"Submit Feedback"@#@
// @key: @#@"back"@#@ @source: @#@"Back"@#@
// @key: @#@"revert"@#@ @source: @#@"Revert"@#@
// @key: @#@"instruction"@#@ @source: @#@"Your feedback is valuable for us. If you have problems using the app, want to request a feature, or report a bug, we’re more than happy to help."@#@
// @key: @#@"fillForm"@#@ @source: @#@"Please fill in the form below and click "@#@
// @key: @#@"useMailBox"@#@ @source: @#@" or directly use your mailbox and send your request to "@#@
// @key: @#@"email"@#@ @source: @#@"Your email address"@#@
// @key: @#@"reply"@#@ @source: @#@"(so we can reply to you)"@#@
// @key: @#@"emailPlaceHolder"@#@ @source: @#@"ronald.app@ringcentral.com"@#@
// @key: @#@"feedbackTopic"@#@ @source: @#@"Feedback topic"@#@
// @key: @#@"topicPlaceHolder"@#@ @source: @#@"Please select an option"@#@
// @key: @#@"bugReport"@#@ @source: @#@"Bug report"@#@
// @key: @#@"featureRequest"@#@ @source: @#@"Feature request"@#@
// @key: @#@"others"@#@ @source: @#@"Others"@#@
// @key: @#@"subject"@#@ @source: @#@"Subject"@#@
// @key: @#@"subjectPlaceHolder"@#@ @source: @#@"Let us know how we can help you"@#@
// @key: @#@"description"@#@ @source: @#@"Full description"@#@
// @key: @#@"descriptionPlaceHolder"@#@ @source: @#@"Please include as much information as possible"@#@
// @key: @#@"send"@#@ @source: @#@"Send Your Feedback"@#@
